<template>
    <div>
        <p>
            <span class="truncatedText" v-html="truncatedText"></span>
            <span :class="{'remainingText': true, 'd-none': !showFullText}" v-html="remainingText"></span>
            &nbsp;
            <span class="more-or-less" @click="toggleText" v-html="showFullText ? lessText : moreText"></span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'TruncatedText',
    props: {
        truncatedText: {
            type: String,
            required: true
        },
        remainingText: {
            type: String,
            required: true
        },
        moreText: {
            type: String,
            required: true,
            default: 'more'
        },
        lessText: {
            type: String,
            required: true,
            default: 'less'
        }
    },
    data() {
        return {
            showFullText: false,
        };
    },
    computed: {
        isTruncated() {
            return this.showFullText;
        }
    },
    methods: {
        toggleText() {
            this.showFullText = !this.showFullText;
        }
    }
};
</script>
